import { routeItem } from '@/types';
import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
const QuoteRequestListPage = lazy(() => import('./pages/QuoteRequestListPage'));

export const quoteRequestsRoutes: routeItem[] = [
  {
    path: 'quote-requests',
    element: <Outlet />,
    permission:'roles.view',
    children: [
      {
        index: true,
        element: <QuoteRequestListPage />,
      },
    ],
  },
];